import { apiRootUrl } from '../assets/constants';
import { showApiErrorAlert } from '../functions/api';

// メディアの取得
export const getMedia = (userId: string) => {
    const api = apiRootUrl + "/storage/" + userId;
    const options = {
        method: "GET",
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => {
            // アラート表示
            if (result.status === 500) {
                showApiErrorAlert(result.status, "メディアの取得");
            }
            // エラー処理
            if (result.status !== 200) {
                throw new Error(result.status);
            }
            // 成功処理
            if (result.status === 200) {
                return result.data;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

// メディアのアップロード
// リクエスト時、headersに"Content-Type": "multipart/form-data"を指定すると正しくデータが送れない
export const uploadMedia = (file: File, userId: string) => {
    const api = apiRootUrl + "/storage?userId=" + userId;
    const formData = new FormData();
    formData.append("FormFile", file);
    const options = {
        method: "POST",
        body: formData,
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => {
            // アラート表示
            if (result.status === 500) {
                showApiErrorAlert(result.status, "メディアのアップロード");
            }
            // エラー処理
            if (result.status !== 200) {
                throw new Error(result.status);
            }
            // 成功処理
            if (result.status === 200) {
                return result.data;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

// メディアの削除
export const deleteMedia = (fileId: string) => {
    const api = apiRootUrl + "/storage/" + fileId;
    const options = {
        method: "DELETE",
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => {
            // アラート表示
            if (result.status === 404 || result.status === 500) {
                showApiErrorAlert(result.status, "メディアの削除");
            }
            // エラー処理
            if (result.status !== 200) {
                throw new Error(result.status);
            }
            // 成功処理
            if (result.status === 200) {
            }
        })
        .catch((error) => {
            console.log(error);
        });
};